module.exports = __webpack_public_path__ + "img/footer_2903.3c89c5d3.png";